/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Col_TimeInputs */

const vi_station_work_col_time = /** @type {(inputs: Station_Work_Col_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ`)
};

/**

* @param {Station_Work_Col_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_col_time = /** @type {((inputs?: Station_Work_Col_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Col_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_col_time(inputs)
});